import { GlobalAppState } from 'rdx/state';

export const selectOfflinePeriods = (state: GlobalAppState) => state.offlinePeriods.offlinePeriods;

export const selectOfflinePeriodsRequestState = (state: GlobalAppState) =>
  state.offlinePeriods.fetchingState;

export const selectOfflinePeriodsCreateRequestState = (state: GlobalAppState) =>
  state.offlinePeriods.createRequestState;

export const selectOfflinePeriodsCreateError = (state: GlobalAppState) =>
  state.offlinePeriods.error;

export const selectOfflinePeriodsCancelRequestState = (state: GlobalAppState) =>
  state.offlinePeriods.cancelRequestState;

export const selectOfflinePeriodsCancelError = (state: GlobalAppState) =>
  state.offlinePeriods.cancelError?.message;
